import { render } from "./Barcode.vue?vue&type=template&id=08e3bac9&scoped=true"
import script from "./Barcode.vue?vue&type=script&lang=ts"
export * from "./Barcode.vue?vue&type=script&lang=ts"

import "./Barcode.vue?vue&type=style&index=0&id=08e3bac9&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-08e3bac9"

export default script